export default __webpack_public_path__ + "static/media/item_9.4286ebb1.png";